import React, { useEffect } from "react";
import {
  ClientBg,
  ClientContainer,
  ClientImageDiv,
  ClientImage,
  ClientTitle,
  TextWrap,
  DemoTitle,
  ClientInfo,
  ClientCard,
  ClientImageCard,
} from "./styles";
import { graphql, useStaticQuery } from "gatsby";
import AOS from "aos";
import "aos/dist/aos.css";
const Clinets = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  const data = useStaticQuery(graphql`
    query clientQuery {
      allFile(
        filter: {
          ext: { regex: "/jpg/" }
          name: { in: ["1", "2", "3", "4", "5", "6"] }
        }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
              fixed(height: 300) {
                ...GatsbyImageSharpFixed
              }
              id
            }
          }
        }
      }
    }
  `);
  return (
    <ClientContainer
      data-aos="zoom-in"
      data-aos-offset="100"
      data-aos-delay="20"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-bottom">
      <ClientTitle>Popular Clients</ClientTitle>

      <ClientBg>
        {data.allFile.edges.map((item, index) => (
          <ClientCard
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ClientImageCard>
              <ClientImage
                key={index}
                //   fixed={item.node.childImageSharp.fixed}
                fluid={item.node.childImageSharp.fluid}
              />
            </ClientImageCard>

            <ClientInfo>
              <TextWrap>
                <DemoTitle>{`Demo Clint # ` + index}</DemoTitle>
              </TextWrap>
            </ClientInfo>
          </ClientCard>
        ))}
      </ClientBg>
    </ClientContainer>
  );
};

export default Clinets;
